export default __webpack_public_path__ + "static/media/home-bg.e85ef9d3.jpg";